import {z} from 'zod'

import {FormValidationInput} from '../../types'

import {MixCharacteristicsConfiguration, MixCharacteristicsForm} from './types'

const materialVariationSchema = z
  .object({
    value: z.string(),
    description: z.string()
  })
  .nullable()

export const mixCharacteristicsSchema = z.object({
  materialVariations: z
    .object({
      slump: materialVariationSchema,
      setControl: materialVariationSchema
    })
    .optional()
})

export const validateMixCharacteristics = (
  data: MixCharacteristicsForm,
  ctx: z.RefinementCtx,
  {
    configuration: {mixCharacteristics: mixCharacteristicsConfiguration}
  }: FormValidationInput<MixCharacteristicsConfiguration>
) => {
  // Mix characteristics are always optional
  // No validation errors needed as selection is optional
  // If specific validation is needed in the future, it can be added here
  
  if (!mixCharacteristicsConfiguration.isEnabled && data.materialVariations) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['materialVariations'],
      message: 'mixCharacteristics-not-allowed'
    })
  }
}
